import { useMemo } from 'react'

import type { UserState } from '@app/store/user'

import { resolveB2BNavigationVisibleContext } from './B2B/useNavigationVisibleContext'
import { resolveB2CNavigationVisibleContext } from './B2C/useNavigationVisibleContext'
import {
  NAVIGATION_MODEL_VARIANT,
  type NavigationModelVariant,
} from './navigationModel'
import type { NavigationVisibleContextResult } from './types'

export const useNavigationVisibleContext = (
  userState: UserState,
  variant: NavigationModelVariant = NAVIGATION_MODEL_VARIANT.B2B
): NavigationVisibleContextResult => {
  return useMemo(() => {
    if (variant === NAVIGATION_MODEL_VARIANT.B2C) {
      return resolveB2CNavigationVisibleContext(userState)
    }

    return resolveB2BNavigationVisibleContext(userState)
  }, [userState, variant])
}
